import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import NotificationBar from '../Parts/NotificationBar.jsx'
import PlanDialog from '../SendLetter/dialogs/PlanDialog';
import { Link } from 'react-router-dom';
import { validateSignin } from '../../utils/validator';
import Loader from "../Parts/Loader";
import Promo from './sections/Promo';

const double = 2;
const styles = theme => ({
  root: {
    display: 'flex',
  },

  signin: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '50%',
    minHeight: '100vh',
    padding: '40px',
    boxSizing: 'border-box',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    flex: 1,
  },

  form: {
    width: '360px',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit * double,
  },

  bottom: {
    marginTop: '40px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },

  title: {
    fontSize: '24px',
    fontWeight: 800,
  },

  button: {
    margin: '26px 0 0 0',
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    fontSize: '15px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  link: {
    color: '#1A65FF',
    textDecoration: 'none',
  },

  row: {
    marginTop: '15px',
  },

  loaderContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    marginTop: '5px', // 少し上にずれているので調整している
  },

  notification: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

class Signin extends React.Component {
  componentWillMount() {
    //log out any sessions if is currently logged in
    this.props.signout();
    document.addEventListener("keydown", this.handleKeyDown, false);
    if ((/keyman-letter/g.test(this.props.pathname))) {
      document.title = 'Keyman Letter';
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      error: Object.assign({}, this.state.error, nextProps.error)
    })
    if (nextProps.isExpiredPlan) {
      this.setState({ showPlanDialog: true });
    }
  }

  state = {
    email: '',
    password: '',
    error: {},
    showPlanDialog: false,
  }

  handleChange = property => event => {
    let value = event.target.value;
    this.setState({
      [property]: value,
    });
  };

  handleSubmit = () => {
    // レスト構文で、loginInfoからそれ以前のプロパティを除外している
    let { error: _error, showPlanDialog: _showPlanDialog, ...loginInfo } = this.state;
    let error = this.validateForm();

    if (Object.keys(error).length === 0) {
      this.props.signin(loginInfo);
    }
  }

  handleKeyDown = e => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      this.handleSubmit();
    }
  }

  validateForm = () => {
    // レスト構文で、loginInfoからそれ以前のプロパティを除外している
    let { error: _error, showPlanDialog: _showPlanDialog, ...loginInfo } = this.state;
    let error = validateSignin(loginInfo);

    this.setState({
      error: error,
    });

    return error;
  }

  renderNotification = () => {
    const { classes } = this.props;

    return (
      <div style={{ position: 'fixed', zIndex: 9000, top: 10, left: '50%', transform: 'translateX(-50%)' }}>
        <NotificationBar
          message={<div className={classes.notification}>
            <span style={{ lineHeight: '26px' }}>
              2021/06/01 よりサービス名がKeyman Letterに変更となりました<span role="img" aria-label="クラッカー" aria-labelledby="クラッカー">🎉</span> お手数ですがブックマークの変更をお願いいたします！<br />
              なお機能の変更や制限はございませんので安心してお使いくださいませ！
            </span>
          </div>}
          type="yellow"
          open={true}
          autoClose={false}
          style={{
            width: "800px",
            fontWeight: 'bold'
          }}
        >
        </NotificationBar>
      </div>
    );
  }

  togglePlanDialog = () => {
    this.setState({ showPlanDialog: !this.state.showPlanDialog });
  }

  renderPlanDialog = () => {
    if (this.state.showPlanDialog) {
      return (
        <PlanDialog
          isOpen={this.state.showPlanDialog}
          toggleDialog={this.togglePlanDialog}
        />
      );
    }
  }

  render() {
    const { classes } = this.props;
    const { error } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.signin}>
          <div className={classes.container}>
            <Typography variant="title" className={classes.title}>Keyman Letterにサインイン</Typography>
            <form className={classes.form}>
              <TextField
                id="email"
                label="メールアドレス"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  disableUnderline: true,
                }}
                placeholder="メールアドレスを入力"
                onChange={this.handleChange('email')}
                error={error.hasOwnProperty('email')}
                helperText={error.email}
                fullWidth
                className={classes.row}
              />
              <TextField
                id="password"
                type="password"
                label="パスワード"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  disableUnderline: true,
                }}
                placeholder="パスワードを入力"
                onChange={this.handleChange('password')}
                error={error.hasOwnProperty('password')}
                helperText={error.password}
                fullWidth
                className={classes.row}
              />
              <Button
                color="primary"
                fullWidth
                onClick={this.handleSubmit}
                className={classes.button}
                onKeyDown={this.handleKeyDown}
                disabled={this.props.isDisableSignin}
              >
                {this.props.isDisableSignin ? (
                  <div className={classes.loaderContainer}>
                    <Loader type="light" size="medium" />
                  </div>)
                  :
                  ("サインイン")
                }
              </Button>
            </form>
          </div>
          <div className={classes.bottom}>
            <Typography variant="body2" style={{ color: '#71737B' }}>パスワードを忘れた場合は<Link to="/forget-password" className={classes.link}>こちら</Link></Typography>
            {this.renderSignUp()}
            <Typography variant="body2" style={{ color: '#71737B', marginTop: '40px' }}>
              ※Keyman Letterの推奨ブラウザはGoogle Chromeです。ダウンロードは<a href="https://www.google.com/intl/ja_ALL/chrome/" target="_blank" rel="noopener noreferrer" className={classes.link}>こちら</a>
            </Typography>
            <Typography variant="body2" style={{ marginTop: '40px' }}>
              <a href="https://keymanletter.com/terms/" target="_blank" rel="noreferrer noopener" className={classes.link} style={{ marginRight: 15 }}>利用規約</a>
              <a href="https://keymanletter.com/userdata_external_transmission/" target="_blank" rel="noopener noreferrer" className={classes.link} style={{ marginRight: 15 }}>外部送信ポリシー
              </a>
              <a href="https://www.vantage.jp/privacy/" target="_blank" rel="noopener noreferrer" className={classes.link}>プライバシーポリシー
              </a>
            </Typography>
          </div>
          {/* {this.renderNotification()} */}
          {this.renderPlanDialog()}
        </div>
        <Promo style={{ width: '50%'}}/>
      </div>
    );
  }

  /**
   * サインアップリンクのエリアの組み立て
   * @todo セルフサーブするようになったらサインアップを利用させる
   */
  renderSignUp = () => {
    const { classes } = this.props;

    if (process.env.REACT_APP_BUILD_ENV === 'production') {
      let url = 'https://keymanletter.com/';
      return (
        <Typography variant="body2" style={{ color: '#71737B' }}>アカウントをお持ちでない場合は<a className={classes.link} href={url}>お申し込み</a>をしてください</Typography>
      );
    } else {
      let url = '/keyman-letter-signup';
      return (
        <Typography variant="body2" style={{ color: '#71737B' }}>アカウントをお持ちでない場合は<Link to={url} className={classes.link}>サインアップ</Link>してください</Typography>
      );
    }
  }
}

Signin.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  isExpiredPlan: PropTypes.bool,
  user: PropTypes.object,
  signin: PropTypes.func.isRequired,
  signout: PropTypes.func.isRequired,
  isDisableSignin: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default withStyles(styles)(Signin);



// WEBPACK FOOTER //
// ./src/components/Signin/Signin.jsx